
import axios from '../config/axios';

export const url = '/api/contacto5026b'


export const createcontacto5026b = ({
  token,
	nombret3do9,
	telefono4uv5s,
	correjzksb,
	mensajeavdvr,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombret3do9 && telefono4uv5s && correjzksb ) {

    axios.post(`${url}//create/basic/68e7fdc6a5fe5912e60031b9`, {
		nombret3do9,
		telefono4uv5s,
		correjzksb,
		mensajeavdvr,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombret3do9) {
		reject({
			status: 'error',
			info: 'Nombre no esta definido',
		});
	}  else if (!telefono4uv5s) {
		reject({
			status: 'error',
			info: 'Telefono no esta definido',
		});
	}  else if (!correjzksb) {
		reject({
			status: 'error',
			info: 'Corre no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

